import { useMemo } from 'react';

import type { Granularity, TimeRangeOption } from '../../types';
import { getCutoffTimestampUTC, getTimestampsUTC } from '../utils/dates';

type UsageTimestampsProps = {
  timeRange?: TimeRangeOption;
  today: Date;
  month?: string;
  granularity?: Granularity;
};

export function useUsageTimestamps({ timeRange, today, month, granularity }: UsageTimestampsProps) {
  const timestamps = useMemo(() => getTimestampsUTC({ timeRange, today, month }), [timeRange, today, month]);
  const cutoff = useMemo(() => getCutoffTimestampUTC(today, granularity), [today, granularity]);

  return {
    from: timestamps.from,
    to: timestamps.to,
    cutoff,
  };
}
